import { connect } from 'react-redux';
import { updatePartCollected, updateProductCollected } from 'Favourites/store/actions';
import { LIST_TYPE } from 'Favourites/store/constants';
import appStorage from 'helpers/AppStorage';

import {
    selectProduct,
} from 'Favourites/store/reducers/data/products';

import {
    selectSelectedStoreId,
} from 'store/reducers/data/stores';

const getPartsStock = (state, parentArticle) =>
    selectProduct(state, parentArticle).stockAvailability?.RetailItemCommChildAvailabilityList ?? false;

const bindPartCollectedStatus = (parts, productId) => {
    if (parts) {
        const partsCollectedStorage = JSON.parse(appStorage('partsCollected')) || {};
        const partsStoredForParent = partsCollectedStorage && partsCollectedStorage[productId];
        for (const part of parts) {
            if (part.collected === undefined) {
                if (partsStoredForParent) {
                    part.collected = partsCollectedStorage[productId][part.ItemNo.$] || false;
                } else {
                    part.collected = false;
                }
            }
        }
    }
    return parts;
};

const bindProductCollectedStatus = (product, productId) => {
    if (product) {
        const productCollectedStorage = JSON.parse(appStorage('productCollected')) || {};
        product.collected = productCollectedStorage[productId] || false;
    }
    return product;
};

const mapStateToProps = (state, ownProps) => {
    const productId = ownProps.productId;
    const product = bindProductCollectedStatus(selectProduct(state, productId), productId);
    const productQuantity = product.quantity;
    const parts = bindPartCollectedStatus(product.childProducts, productId);
    const partsStock = getPartsStock(state, productId);
    const showChildren = true;
    const store = selectSelectedStoreId(state);
    const productAvailability = product.stockAvailability;
    const articleNumberFormatted = product.articleNumberFormatted;

    return { product, productId, productQuantity, parts, partsStock, showChildren, store, productAvailability, articleNumberFormatted };
};

const mapDispatchToProps = (dispatch) => {
    return {
        triggerUpdatePartCollected: (part, productId) => {
            const partId = part.ItemNo.$;
            const collected = !part.collected;
            const partsCollectedStorage = JSON.parse(appStorage('partsCollected')) || {};
            dispatch(updatePartCollected(partId, collected, productId, LIST_TYPE));
            appStorage('partsCollected', {
                ...partsCollectedStorage,
                [productId]: {
                    ...partsCollectedStorage[productId],
                    [partId]: collected,
                },
            });
        },
        triggerUpdateProductCollected: (product, productId) => {
            const collected = !product.collected;
            const productCollectedStorage = JSON.parse(appStorage('productCollected')) || {};
            dispatch(updateProductCollected(collected, product, productId, LIST_TYPE));
            appStorage('productCollected', {
                ...productCollectedStorage,
                [productId]: collected,
            });
        },
        updatePartCollected: (part, productId) => {
            dispatch(updatePartCollected(part.ItemNo.$, part.collected, productId, LIST_TYPE));
        },
        updateProductCollected: (collected, product, productId) => {
            dispatch(updateProductCollected(collected, product, productId, LIST_TYPE));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
